import axios from 'axios';
import { Tab } from 'bootstrap';
import { useEffect, useState } from 'react';
import { Button, Container, Tabs } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { useDenominaciones } from '../../../../appStore/denominaciones';
import { CONCURSOAPI, GREMIOS } from '../../../../const';
import es from '../../../../yup-es';
import { AlertaDialog } from '../../../CompUtils/Alerta';
import ErrorMsg from '../../../CompUtils/ErrorMsg';
import FormSection from '../../../CompUtils/FormSection';
import { finalize, init } from '../../../GlobalFeedback/feedbackSlice';
import MiembrosComite from '../CargaCoordConcur/MiembrosComite';
import { fetchRolComite } from '../gestionConcursoSlice';
import { CargaPuestos } from './CargaPuestos';
import { IntervencionForm } from './IntervercionFom';
import SolicitudRespuestaVeedores from './SolicitudRespuestaVeedores';

yup.setLocale(es);

const DesignacionVeedores = ({ concurso }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [alert, setAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState();
  const [alertDerivacion, setAlertDerivacion] = useState(false);
  const [errorMsgVeedores, setErrorMsgVeedores] = useState('');
  const [errorMsgFuncion, setErrorMsgFuncion] = useState('');
  const [alertDerivacionMsg, setAlertDerivacionMsg] = useState('');
  const [solicitudVeedores, setSolicitudVeedores] = useState({});
  const [solicitudVeedoresEnviada] = useState({});
  const [comite, setComite] = useState({ usuarios: {} });
  const [showButtonAvanzarConcurso, setShowButtonAvanzarConcurso] = useState(false);

  const { dataPublico } = useDenominaciones();

  const onConfirmarVeedores = () => {
    confirmarSolicitudRespuesta();
    confirmarComite();
  };
  const confirmarSolicitudRespuesta = () => {
    dispatch(init());
    let solicitudRespuesta = {
      idComite: concurso.comite[0].idComite,
      solicitudes: [
        {
          gremio: GREMIOS.ATE,
          idSolicitudRespuestaVeedor: solicitudVeedores.idAte,
          fechaSolicitud: solicitudVeedores.fechaSolicitudAte,
          nroSolicitud: solicitudVeedores.numeroSolicitudAte,
          fechaRespuesta: solicitudVeedores.fechaRespuestaAte,
          nroRespuesta: solicitudVeedores.numeroRespuestaAte,
        },
        {
          gremio: GREMIOS.UPCN,
          idSolicitudRespuestaVeedor: solicitudVeedores.idUpcn,
          fechaSolicitud: solicitudVeedores.fechaSolicitudUpcn,
          nroSolicitud: solicitudVeedores.numeroSolicitudUpcn,
          fechaRespuesta: solicitudVeedores.fechaRespuestaUpcn,
          nroRespuesta: solicitudVeedores.numeroRespuestaUpcn,
        },
        {
          gremio: GREMIOS.MINMUJ,
          idSolicitudRespuestaVeedor: solicitudVeedores.idMinmuj,
          fechaSolicitud: solicitudVeedores.fechaSolicitudMinmuj,
          nroSolicitud: solicitudVeedores.numeroSolicitudMinmuj,
          fechaRespuesta: solicitudVeedores.fechaRespuestaMinmuj,
          nroRespuesta: solicitudVeedores.numeroRespuestaMinmuj,
        },
        {
          gremio: GREMIOS.MINTRA,
          idSolicitudRespuestaVeedor: solicitudVeedores.idMintra,
          fechaSolicitud: solicitudVeedores.fechaSolicitudMintra,
          nroSolicitud: solicitudVeedores.numeroSolicitudMintra,
          fechaRespuesta: solicitudVeedores.fechaRespuestaMintra,
          nroRespuesta: solicitudVeedores.numeroRespuestaMintra,
        },
      ],
    };
    axios
      .post(`${CONCURSOAPI}/solicitudrespuestaveedor/`, solicitudRespuesta)
      .then((res) => {
        axios
          .get(`${CONCURSOAPI}/solicitudrespuestaveedor/${concurso.comite[0].idComite}`, {})
          .then((res) => {
            if (res.data) {
              mapearRespuestaASolicitud(res.data);
            } else {
              throw new Error('Error al recuperar datos de solicitudes de veedores.!');
            }
          })
          .catch((err) => {
            console.error(err.response.data ? err.response.data.message : err.response);
            throw new Error('Error al recuperar datos de solicitudes de veedores.!');
          });
      })
      .catch((err) => {
        console.error(err.response.data ? err.response.data.message : err.response);
        throw new Error('Error al persistir datos de solicitudes de veedores.!');
      });
  };
  function mapearRespuestaASolicitud(data) {
    const mapElement = (elem, gremio) => {
      const solicitudVeedoresEnviadaKey = `id${gremio}`;
      const numeroSolicitudKey = `numeroSolicitud${gremio}`;
      const fechaSolicitudKey = `fechaSolicitud${gremio}`;
      const fechaRespuestaKey = `fechaRespuesta${gremio}`;
      const numeroRespuestaKey = `numeroRespuesta${gremio}`;

      solicitudVeedoresEnviada[solicitudVeedoresEnviadaKey] = elem.idSolicitudRespuestaVeedor
        ? elem.idSolicitudRespuestaVeedor
        : null;
      solicitudVeedoresEnviada[numeroSolicitudKey] = elem.numeroSolicitud
        ? elem.numeroSolicitud
        : '';
      solicitudVeedoresEnviada[fechaSolicitudKey] = elem.fechaSolicitud ? elem.fechaSolicitud : '';
      solicitudVeedoresEnviada[fechaRespuestaKey] = elem.fechaRespuesta ? elem.fechaRespuesta : '';
      solicitudVeedoresEnviada[numeroRespuestaKey] = elem.numeroRespuesta
        ? elem.numeroRespuesta
        : '';
    };

    data.forEach((elem) => {
      switch (elem.gremio) {
        case GREMIOS.MINMUJ:
          mapElement(elem, 'Minmuj');
          break;
        case GREMIOS.MINTRA:
          mapElement(elem, 'Mintra');
          break;
        case GREMIOS.ATE:
          mapElement(elem, 'Ate');
          break;
        case GREMIOS.UPCN:
          mapElement(elem, 'Upcn');
          break;
        default:
          break;
      }
    });
  }

  const confirmarComite = () => {
    //Acomodo la estructura de usuarios del comité para que coincida con el backend
    const usuarios = Object.keys(comite.usuarios).reduce((acum, curKey) => {
      acum[curKey] = comite.usuarios[curKey].reduce((rolesAcum, rol) => {
        return [
          ...rolesAcum,
          {
            idUsuario: rol.idUsuario,
            titular: rol.titular,
            representacion: rol.representacion,
          },
        ];
      }, []);
      return acum;
    }, {});

    const reqData = {
      idComite: concurso.comite[0].idComite,
      idLlamadoConcurso: concurso.idLlamadoConcurso,
      usuarios,
    };

    setErrorMsgVeedores('');

    axios
      .put(`${CONCURSOAPI}/llamadoconcurso/comites`, reqData)
      .then((res) => {
        axios
          .get(`${CONCURSOAPI}/llamadoconcurso/comites`, {
            params: {
              idLlamadoConcurso: concurso.idLlamadoConcurso,
            },
          })
          .then((res) => {
            if (res.data[0].usuario) {
              setComite({
                usuarios: res.data[0].usuario,
              });
            } else {
              alert('No es posible obtener los miembros del comite');
              throw new Error('Error al obtener los miembros del comite.!');
            }
            dispatch(finalize());
            setAlertMsg('Datos ingresados correctamente');
            setAlert(true);
          })
          .catch((err) => {
            console.error(err.response.data ? err.response.data.message : err.response);
            throw new Error('Error al obtener los miembros del comite.!');
          });
      })
      .catch((error) => {
        if (error.response) {
          setErrorMsgVeedores(
            error.response.data.message || 'Error al intentar conectarse al servidor.',
          );
        } else if (error.request) {
          setErrorMsgVeedores('Error de comunicación con el servidor');
        } else {
          setErrorMsgVeedores(error.message);
        }
        throw new Error('Error al persistir los miembros del comite.!');
      });
  };
  const onDerivarConcurso = () => {
    dispatch(init());
    axios
      .post(`${CONCURSOAPI}/llamadoconcurso/avanzaretapa/${concurso.idLlamadoConcurso}`)
      .then((res) => {
        if (res.data) {
          setAlertDerivacionMsg('Concurso enviado a Legales satisfactoriamente.');
          setAlertDerivacion(true);
        } else {
          throw new Error('No es posible obtener los datos de solicitud y respuesta');
        }
        dispatch(finalize());
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log(error.message);
        }
      });
  };
  function showBotonAvanzarConcurso(value) {
    setShowButtonAvanzarConcurso(value);
  }
  const finalizarConfirmacion = () => {
    setAlert(false);
  };
  const finalizarDerivacion = () => {
    setAlertDerivacion(false);
    history.push('/concursos');
  };

  useEffect(() => {
    dispatch(fetchRolComite());
    axios
      .get(`${CONCURSOAPI}/solicitudrespuestaveedor/${concurso.comite[0].idComite}`, {})
      .then((res) => {
        if (res.data) {
          mapearRespuestaASolicitud(res.data);
        } else {
          alert('No es posible obtener los datos de solicitud y respuesta');
        }
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log(error.message);
        }
      });
  }, [comite]);
  return (
    <>
      <Tabs defaultActiveKey="veedores" id="tab-cc-veedores" className="mb-3">
        <Tab eventKey="veedores" title="Veedores">
          <Container fluid>
            <br></br>
            <SolicitudRespuestaVeedores
              solicitudVeedoresDTO={(solicitudVeedoresDTO) => {
                setSolicitudVeedores(solicitudVeedoresDTO);
              }}
              soliditudRespuestaRecibida={solicitudVeedoresEnviada}></SolicitudRespuestaVeedores>
            <FormSection></FormSection>
            <div className="container-fluid">
              <MiembrosComite
                idConcurso={concurso.idLlamadoConcurso}
                comiteRecived={comite}
                newComite={(newComite) => setComite(newComite)}
              />
              {errorMsgVeedores && <ErrorMsg msg={errorMsgVeedores} />}
            </div>
            <Button variant="success" onClick={onConfirmarVeedores}>
              Guardar
            </Button>
          </Container>
        </Tab>
        <Tab eventKey="funcion" title="DNDO/DGYDCP">
          <Container fluid>
            <IntervencionForm
              concurso={concurso}
              errorDTO={(error) => setErrorMsgFuncion(error)}></IntervencionForm>
            {errorMsgFuncion && <ErrorMsg msg={errorMsgFuncion} />}
          </Container>
        </Tab>
        <Tab eventKey="contact" title="Denominaciones">
          <Container fluid>
            <CargaPuestos
              idLlamadoConcurso={concurso.idLlamadoConcurso}
              showAvanzarConcurso={(value) => showBotonAvanzarConcurso(value)}></CargaPuestos>
            <FormSection></FormSection>
            {(showButtonAvanzarConcurso || (dataPublico || []).length > 0) && (
              <div className="d-grid gap-2" style={{ display: 'flex' }}>
                <Button
                  variant="success"
                  size="lg"
                  style={{ marginLeft: 'auto' }}
                  onClick={onDerivarConcurso}>
                  Derivar <i className="fa fa-arrow-right"></i>
                </Button>
              </div>
            )}
          </Container>
        </Tab>
      </Tabs>

      <AlertaDialog size="sm" show={alert} onClose={finalizarConfirmacion} closeText="Cerrar">
        <div className="text-center">
          <i
            className="text-success fa fa-check-circle-o"
            style={{ fontSize: 64, WebkitTextStroke: '5px white' }}></i>
          <p>{alertMsg}</p>
        </div>
      </AlertaDialog>
      <AlertaDialog
        size="sm"
        show={alertDerivacion}
        onClose={finalizarDerivacion}
        closeText="Cerrar">
        <div className="text-center">
          <i
            className="text-success fa fa-check-circle-o"
            style={{ fontSize: 64, WebkitTextStroke: '5px white' }}></i>
          <p>{alertDerivacionMsg}</p>
        </div>
      </AlertaDialog>
    </>
  );
};

export default DesignacionVeedores;
